export default __webpack_public_path__ + "../staticImages/audi_logo_white_sl.svg";